<div class="success-page">

  <!-- Loading State -->
  <ng-container *ngIf="isLoading">
    <app-loading [size]="'large'" [fullScreen]="true" [message]="'Rezervasyon doğrulanıyor...'"></app-loading>
  </ng-container>

  <!-- Success State -->
  <ng-container *ngIf="!isLoading && bookingNumber && !errorMessage">
    <div class="icon-success">✓</div>
    <h2>Ödeme Başarılı</h2>
    <div class="booking-number">{{ bookingNumber }}</div>


    <span class="email-note">Rezervasyon detaylarınız e-posta adresinize gönderildi</span>

    <button (click)="goToHome()">Ana Sayfaya Dön</button>
  </ng-container>

  <!-- Error State -->
  <ng-container *ngIf="!isLoading && errorMessage">
    <div class="icon-error">✕</div>
    <h2>Hata Oluştu</h2>
    <p>{{ errorMessage }}</p>
    <span class="email-note">Yönlendiriliyorsunuz...</span>
  </ng-container>

</div>